import { apiFetch } from 'utils/apiFetch'

export const serviceCenterNodeRemoveReasonsGet = async () => {
  const removeReasons = await apiFetch({ url: '/service-center-node-remove-reasons', body: null })

  return removeReasons
}
